export interface RoleForm {
  role_id: string
  name: string
  permission: []
}

export const initialValues: RoleForm = {
  role_id: '0',
  name: '',
  permission: [],
}
